<template>
  <div class="help-section help-documentation">
    <div class="section-header">
      <div @click="back" class="icon icon--s icon-back mr-3"></div>
      Documentazione
    </div>
    <div class="section-intro">
      <p class="section-intro--title f-m">
        Livello A
      </p>
    </div>
    <div class="section-content">
      <div
        v-for="t in terms"
        :key="t.id"
        class="section-row cursor-pointer justify-between f-m"
        @click="openTerm(t.id)"
      >
        <p class="section-text">{{ t.description }}</p>
        <div
          class="icon icon-download icon--s section-icon"
          style="background-position-x: right; width: 5%;"
        ></div>
      </div>
      <div
        v-for="d in documents"
        :key="d.id"
        class="section-row cursor-pointer justify-between f-m"
        @click="openDocument(d.documentId)"
      >
        <p class="section-text">{{ d.description }}</p>
        <div class="icon icon-download icon--s section-icon"></div>
      </div>
    </div>
  </div>
</template>

<script>
import DocumentsService from "@/services/DocumentsService";
//import UtilityService from "@/services/UtilityService";

export default {
  name: "HelpDocumentation",
  components: {},

  data() {
    return {
      documents: [],
      terms: []
    };
  },
  mounted() {
    //since we don't need data right on page load we set a timeout
    // to wait until 'upgrade' property being setted
    setTimeout(this.getData, 1000);
  },
  methods: {
    openTerm(id) {
      DocumentsService.openTerm(id);
    },
    openDocument(id) {
      var url = DocumentsService.getStaticContractUrlFromId(id);
      DocumentsService.openDocument(url);
    },
    getData() {
      this.getContracts();
      this.getTerms();
    },
    getTerms() {
      DocumentsService.getTerms().then(response => {
        this.terms = response.terms.filter(
          t => t.radio === false && t.type === 0
        );
      });
    },
    getContracts() {
      //const isUpgrade = sessionStorage.getItem("upgrade");
      //TODO: check this
      const condition = /* isUpgrade ? this.upgradeDoc : */ this.consumerDoc;

      DocumentsService.getStaticContracts().then(response => {
        this.documents = response.staticContracts
          .filter(d => d.status === 1 && condition(d))
          .map(d => {
            if (d.documentId === "INF_PCU1") {
              d.description = "Informativa privacy Infocert";
            }
            return d;
          });

        //this.documents = UtilityService.sort(this.documents, "description");
      });
    },
    consumerDoc(d) {
      return (
        d.type === "UNICO_BP" ||
        d.type === "UNICO_I" ||
        d.type === "GD_AZIENDA" ||
        d.type === "GD_PRIVATI" ||
        d.type === "UNICO_CSI" ||
        d.type === "UNICO_BP_M"
      );
    },
    upgradeDoc(d) {
      return d.type === "UL2M";
    },

    back() {
      this.$root.$emit("helpBack");
    }
  }
};
</script>
<style lang="less" scoped>
.section-row {
  .section-text {
    width: 95%;
    font-size: 11px;
    padding-right: 10px;
  }
  .section-icon {
    background-position-x: 100%;
    width: 5%;
  }
}
</style>
